// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useQuery, QueryHookOptions } from "@apollo/client";
import { getAccount } from "../types/getAccount";

export const useGetAccountQuery = (opts: QueryHookOptions<getAccount, {}>) => {
  return useQuery<getAccount, {}>(getAccountQuery, opts);
};

export const getAccountQuery = gql`
  query getAccount {
    account {
      id
      verifiedEmail
      verifiedPhone
      email
      phoneNo
      intercomId
      partnerId
      hasIM1Enabled
      hasNhsLoginEnabled
      patients {
        edges {
          node {
            id
            isAccountHolder
            firstName
            lastName
            pdsTraceAttemptsRemaining
            pdsRetrieveAttemptsRemaining
            nhsNumber
            practice {
              id
              im1Enabled
            }
          }
        }
      }
    }
  }
`;

export function refetchGetAccountQuery() {
  return {
    query: getAccountQuery
  };
}
